var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper"},[_c('a',{attrs:{"href":_vm.homeUrl}},[_c('img',{staticClass:"vexels-logo",attrs:{"src":"https://cdn.vexels.com/img/logo-variants/default-logo-variant.svg","alt":_vm.$t('main.header.logo.vexelsLogoAlt'),"width":"130","height":"29"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }